import { Table } from "antd";
import { useTranslation } from "react-i18next";
import { Alert } from "../../../api/models";
import { PagedApiState } from "../../../api/useApiState";
import { toAntdPagination } from "../../../util";
import { formatLocalizedDateTime } from "../../../util/formatting";

export enum AlertTableColumns {
  Alert = "alert",
  Description = "descr",
  CreatedAt = "ts",
}

interface AlertTableProps {
  isLoading: boolean;
  alertHistory: PagedApiState<Alert>;
}

export function AlertTable({ alertHistory, isLoading }: AlertTableProps) {
  const { t } = useTranslation();
  const columns = [
    {
      key: "ts",
      title: t("timestamp"),
      width: "auto",
      render: (e: Alert) => formatLocalizedDateTime(e.ts),
    },
    {
      key: "alert",
      title: t("error:alerts"),
      width: "auto",
      render: (e: Alert) => e.alert,
    },
    {
      key: "descr",
      title: t("error:data"),
      width: "auto",
      render: (e: Alert) => e.descr,
    },
  ];

  return (
    <Table
      sticky
      style={{ gridColumn: "1 / -1" }}
      dataSource={alertHistory.value?.items || []}
      rowKey={(record) => `${record.alert}-${record.ts}-${Math.random()}`}
      size="middle"
      loading={isLoading}
      columns={columns}
      pagination={toAntdPagination(alertHistory, false)}
    ></Table>
  );
}
